module.exports = __webpack_public_path__ + "img/farmstead-hero2.09c07ad7.png";